import actions from './actions.js';
import reducer from './reducer.js';

const password = {
    actions,
    reducer
};

export default password;
